import React, { useRef, useState, useCallback, useEffect } from "react"
import PropTypes from "prop-types"
import { motion, AnimatePresence } from "framer-motion"
import style from "./HeaderPhone.module.css"
// import phoneImg from "../../assets/images/iPhone.png"
import cyanImg from "../../assets/images/screenshots/lifewheel/lifewheel-cyan.png"
import redImg from "../../assets/images/screenshots/lifewheel/lifewheel-red.png"
import yellowImg from "../../assets/images/screenshots/lifewheel/lifewheel-yellow.png"
import purpleImg from "../../assets/images/screenshots/lifewheel/lifewheel-purple.png"
// import IntersectionObserverWrapper from "../ioWrapper/IOWrapper"

const headerScreenshots = {
  cyan: cyanImg,
  yellow: yellowImg,
  purple: purpleImg,
  red: redImg,
}

const headerPhoneVariants = {
  right: { x: 400, opacity: 0, zIndex: 1 },
  middle: { x: 0, opacity: 1, zIndex: 2 },
  left: { x: -400, opacity: 0, zIndex: 1 },
}

const HeaderPhone = ({ colour }) => {
  return (
    <div className={style.phone}>
      <AnimatePresence initial={false}>
        <motion.img
          key={colour}
          src={headerScreenshots[colour]}
          alt="Fufil Screenshot"
          variants={headerPhoneVariants}
          // animate=''
          initial="right"
          animate="middle"
          exit="left"
          transition={{ duration: 0.6 }}
        />
      </AnimatePresence>
    </div>
  )
}

HeaderPhone.propTypes = {
  colour: PropTypes.string.isRequired,
  customClass: PropTypes.string,
}

HeaderPhone.defaultProps = {
  colour: "cyan",
}

export default HeaderPhone
